import * as React from 'react';
import { SVGProps } from 'react';

const IconHamburgerSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 3H1V2h10v1zm0 3H1V5h10v1zM1 9h10V8H1v1z" />
  </svg>
);
export default IconHamburgerSizeXs;
